<mat-list-option
  class="list-item list-item-users"
  class="list-item list-item-users"
  [value]="data?.id"
  [selected]="!loading && selectedId === data?.id"
>
  <div
    matListIcon
    class="list-item__image list-item__image_large"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_rounded]="loading"
  >
    <tui-avatar
      [src]="userAvatarUrl ? (userAvatarUrl | safe: 'url') : (data | userDisplayableName: 'short' | tuiInitials)"
      [size]="'m'"
      [round]="true"
      [style.background]="
        !userAvatarUrl && (data | userDisplayableName: 'short')
          ? (data | userDisplayableName: 'short' | tuiAutoColor)
          : ('' | tuiAutoColor)
      "
    ></tui-avatar>
  </div>

  <div class="list-item__text-box list-item__text-box_both-padding">
    <h3 class="list-item__title" [class.tui-skeleton]="loading" [class.tui-skeleton_text]="loading">
      {{ data | userDisplayableName }}
    </h3>

    <p
      *ngFor="let organisationJobTitle of jobTitles"
      class="list-item__text list-item__text_grey"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      {{ organisationJobTitle | orgJobTitleDisplayableName }}
    </p>

    <div *ngIf="editDateNormalize" class="list-item__text list-item__text_grey">
      {{ editDateNormalize }}
    </div>

    <div
      *ngIf="data && data.decisionTypeName"
      class="list-item__status"
      [class.list-item__status_blue]="data.decisionTypeCode === 0 || data.decisionTypeCode === 1"
      [class.list-item__status_green]="data.decisionTypeCode === 2 || data.decisionTypeCode === 4"
      [class.list-item__status_red]="data.decisionTypeCode === 3"
    >
      {{ data.decisionTypeName }}
    </div>
  </div>
</mat-list-option>
